const { MinimogThemeStyles, MinimogThemeScripts } = window;

class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
    this.isOpen = false;
    this.isLoading = false;

    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.isLoading) return;
        this.target = target;
        this.toggleLoading(true);
        const productHandle = target.dataset.productHandle;
        if (productHandle) this.loadProductQuickView(productHandle);
      },
    });

    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) {
        this.clearModalContent();
        this.modal.close();
      }
      this.isOpen = false;
    });
    window.MinimogEvents.subscribe("ON_MODAL_CLOSED", () => {
      this.close();
    });
  }

  clearModalContent() {
    if (this.modal && typeof this.modal.removeChild === "function") {
      this.modal.removeChild();
    }
  }

  scriptAlreadyLoaded(src) {
    if (!src) return false;

    if (src.includes("product-info") && customElements.get("product-info")) return true;
    if (src.includes("product-media") && customElements.get("media-gallery")) return true;
    if (src.includes("variant-picker") && customElements.get("variant-picker")) return true;
    if (src.includes("product-model") && customElements.get("product-model")) return true;
    if (src.includes("show-more") && customElements.get("show-more")) return true;
    if (src.includes("price-per-item") && customElements.get("price-per-item")) return true;

    const existing = document.querySelector(`script[src="${src}"]`);
    if (!existing) return false;
    if (existing.dataset.loaded === "true") return true;
    // Theme <script defer> tags already executed after page load
    if (document.readyState === "complete") return true;
    return false;
  }

  processQuickViewScripts(sectionRoot) {
    const toLoad = [];
    if (!sectionRoot) return toLoad;

    sectionRoot.querySelectorAll("script").forEach((oldScriptTag) => {
      try {
        const src = oldScriptTag.getAttribute("src");

        if (src) {
          if (this.scriptAlreadyLoaded(src)) {
            oldScriptTag.remove();
            return;
          }
          // Load once into document.head; do not re-execute inside the modal
          toLoad.push(src);
          oldScriptTag.remove();
          return;
        }

        // Reinject inline scripts (application/json ModelJSON, etc.)
        const newScriptTag = document.createElement("script");
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      } catch (scriptError) {
        console.error("Error processing quick view script:", scriptError);
      }
    });

    return [...new Set(toLoad)];
  }

  loadProductQuickView(productHandle) {
    if (this.isOpen) {
      this.clearModalContent();
      this.isOpen = false;
    }

    this.isLoading = true;
    fetchSection("product-quickview", {
      url: `${window.MinimogSettings.base_url}products/${productHandle}`,
    })
      .then((html) => {
        this.modalContent = html.querySelector("#MainProduct-quick-view__content");
        if (!this.modalContent) {
          throw new Error("Quick view content missing");
        }

        const productInfo = this.modalContent.querySelector("product-info");
        const colorScheme =
          (productInfo && productInfo.dataset && productInfo.dataset.colorScheme) || "";

        this.clearModalContent();
        this.modal.appendChild(this.modalContent);
        this.modal.setWidth("960px");

        const sectionWrapper =
          this.modal.modal.querySelector("#MainProduct-quick-view__content") || this.modalContent;
        const externalSrcs = this.processQuickViewScripts(sectionWrapper);

        const loadPromise =
          externalSrcs.length && typeof loadJS === "function"
            ? Promise.all(externalSrcs.map((src) => loadJS(src, document.head)))
            : Promise.resolve();

        return loadPromise.then(() => {
          this.modal.open();
          this.modal.setSizes(`m-gradient ${colorScheme}`);
          this.toggleLoading(false);
          this.isOpen = true;
          this.isLoading = false;
        });
      })
      .then(() => {
        if (!this.target) return;

        document.dispatchEvent(
          new CustomEvent("tcustomizer-custom-show-quick-view", {
            detail: { productHandle: this.target.dataset.productHandle },
          })
        );

        document.dispatchEvent(
          new CustomEvent("quick-view:loaded", {
            detail: { productUrl: this.target.dataset.productHandle },
          })
        );
      })
      .catch((error) => {
        console.error("Error loading product quick view:", error);
        this.toggleLoading(false);
        this.isLoading = false;
        this.isOpen = false;
      });
  }

  close() {
    this.isOpen = false;
  }

  toggleLoading(isLoading) {
    if (!this.target) return;
    if (isLoading) {
      this.target.classList.add("m-spinner-loading");
    } else {
      this.target.classList.remove("m-spinner-loading");
    }
  }
}

MinimogTheme.ProductQuickView = new QuickView();
